
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"26","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.957 1.93a1 1 0 01.937-.652h7.775a1 1 0 01.916 1.401L15.37 7.74h3.771l.016.001c.37.006.716.138.995.358l-.62.785.62-.785a1.8 1.8 0 01.582.826l-.945.327.945-.327c.109.315.132.655.07.981-.062.326-.21.64-.442.896l-.006.006h0L8.216 23.957a1 1 0 01-1.705-.921L9.027 12.97H6.36h0a1.637 1.637 0 01-.85-.245L7.957 1.93zm0 0l-3.18 8.578h0m3.18-8.577l-3.18 8.577m0 0l-.004.01m.003-.01l-.003.01m0 0c-.094.26-.128.538-.105.811m.105-.811l-.105.811m0 0c.024.274.107.543.248.786m-.248-.786l.248.786m0 0c.142.242.342.456.593.61l-.593-.61z","fill":"url(#paint0_linear_3010_41674)","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_3010_41674","x1":"12.431","y1":"17.015","x2":"11.799","y2":"-15.219","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".115","stop-color":"#EDC843"}}),_c('stop',{attrs:{"offset":".115","stop-color":"#141F31","stop-opacity":"0"}})])])])
          )
        }
      }
    